import React from 'react';
import "./loading.css"; // Add your custom styles here

const Loading = () => (
  <div className="loading">
    <div className="spinner"></div>
    {/* <p>Loading...</p> */}
  </div>
);

export default Loading;
